import Index from "../components/sections/Index";

export const privateRoute = [
    {
        path: "/",
        element: <Index />,
    },
]